<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <p>
          If you wish to highlight this category whenever an item is set as R&amp;R/R&amp;I, turn on the 'Set Highlight' checkbox. Also, supply a
          Notice that'll appear on the report and be presented to the user in the portal and mobile app.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <input v-model="isHighlight" type="checkbox" class="custom-checkbox custom-inactive custom-highlight" @click="changed" />
        <span>Set Highlight?</span>
      </div>
      <div class="col-md-9">
        <z-textarea v-model="highlightNotice" :rows="4" name="notice" label="Highlight Notice" @keyup="changed" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTextarea from '@/components/utilities/elements/TextArea.vue'
export default {
  name: 'MatrixHighlight',
  components: {
    ZTextarea
  },
  props: {
    value: Object
  },
  emits: ['changed'],
  computed: {
    ...mapState(adasmatrixStore, ['adasmatrix']),
    isHighlight: {
      get() {
        let _data = false
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.isHighlight
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'isHighlight',
          value: value
        })
      }
    },
    highlightNotice: {
      get() {
        let _data = ''
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.notice
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'notice',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['setData']),
    changed() {
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
.custom-inactive {
  margin-top: 42px;
}
.custom-highlight {
  margin-left: 10px;
}
</style>
